import { FunctionComponent } from "react";

import {
	usePreviewDynamicsFieldMappingsMutation,
	useTestDynamicsSyncMutation,
} from "@/pages/Private/redux/dynamics/dynamics.api";

import { MsdynamicsEntityType, MsdynamicsField, MsdynamicsSourceField } from "../schema/dynamics";
import {
	buildDynamicsMappingPreviewLabels,
	buildDynamicsPreviewOutcome,
	buildDynamicsTestSyncOutcome,
	MappingPreviewModal,
} from "./fieldMapping";
import { AiConfigProspectOption } from "./fieldMapping/aiConfig.types";

type Ts = (key: string, options?: Record<string, unknown>) => string;

interface DynamicsMappingPreviewModalProps {
	isOpen: boolean;
	entityType: MsdynamicsEntityType;
	sourceFields: MsdynamicsSourceField[];
	msdynamicsFields: MsdynamicsField[];
	ts: Ts;
	onClose: () => void;
	onSearchProspects: (query: string) => Promise<AiConfigProspectOption[]>;
	onCancelSearchProspects?: () => void;
}

/**
 * Dynamics 365 binding for the generic MappingPreviewModal: the dry-run preview (whose
 * per-row warnings are Dataverse's own coercion verdicts, resolved by the API) plus the
 * real single-lead test sync.
 */
export const DynamicsMappingPreviewModal: FunctionComponent<DynamicsMappingPreviewModalProps> = ({
	isOpen,
	entityType,
	sourceFields,
	msdynamicsFields,
	ts,
	onClose,
	onSearchProspects,
	onCancelSearchProspects,
}) => {
	const [previewMappings] = usePreviewDynamicsFieldMappingsMutation();
	const [testSync] = useTestDynamicsSyncMutation();

	return (
		<MappingPreviewModal
			isOpen={isOpen}
			labels={buildDynamicsMappingPreviewLabels(ts, entityType)}
			onCancelSearchProspects={onCancelSearchProspects}
			onClose={onClose}
			onRunPreview={async (prospectId) =>
				buildDynamicsPreviewOutcome(
					await previewMappings({ prospectId, entityType }).unwrap(),
					sourceFields,
					msdynamicsFields,
					ts
				)
			}
			onSearchProspects={onSearchProspects}
			onTestSync={async (prospectId) =>
				buildDynamicsTestSyncOutcome(await testSync({ prospectId, entityType }).unwrap(), ts)
			}
		/>
	);
};
